import { useState } from "react";
import { notification, Tooltip } from "antd";
import Icon from "@assets/icon_config";
import "./topFilter.scss";
import { isEmpty } from "lodash";
import exportToExcel from "@utils/applyExcelStyle";
import { useChronicBreakdownStore } from "@stores/chronicBreakdownStore";
import reportService from "@services/report.service";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Spinner } from "@components/healthemSpinner/healthemSpinner";

const TopFilters = () => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const selectedCity = useChronicBreakdownStore((state) => state.selectedCity);
  const selectedState = useChronicBreakdownStore((state) => state.selectedState);
  const selectedHealthPlan = useChronicBreakdownStore((state) => state.selectedHealthPlan);
  const selectedPCPVendor = useChronicBreakdownStore((state) => state.selectedPCPVendor);
  const selectedProvider = useChronicBreakdownStore((state) => state.selectedProvider);
  const chartData = useChronicBreakdownStore((state) => state.chartData);
  const loadingCity = useChronicBreakdownStore((state) => state.loadingCity);
  const loadingHealthPlan = useChronicBreakdownStore((state) => state.loadingHealthPlan);
  const loadingPcpVendor = useChronicBreakdownStore((state) => state.loadingPcpVendor);
  const loadingProviders = useChronicBreakdownStore((state) => state.loadingProviders);

  const exportData = (data: any[]) => {
    if (!data || data.length === 0) {
      notification.info({
        message: "No data to export",
        icon: <InfoCircleOutlined style={{ color: "#1890ff" }} />,
      });
      return;
    }
    const columns = Object.keys(data[0]).map((key) => ({
      header: key.replace(/_/g, " ").toUpperCase(),
      key: key,
    }));

    exportToExcel({
      filename: "Chronic Breakdown Report.xlsx",
      sheets: [
        {
          sheetName: "Chronic Breakdown",
          columns: columns,
          data: data,
          styles: { headerBold: true },
        },
      ],
    });
  };

  const handleExportChronicBreakdownReport = () => {
    setShowLoader(true);
    reportService.exportChronicBreakdown(selectedState, selectedCity, selectedHealthPlan, selectedPCPVendor, selectedProvider).subscribe({
      next: (response) => {
        const fileData = response?.data?.data;
        setShowLoader(false);
        exportData(fileData);
      },
      error: (error) => {
        console.error(error);
        setShowLoader(false);
      },
    });
  };

  const isDownloadDisabled = isEmpty(chartData) || isEmpty(selectedProvider) || loadingCity || loadingHealthPlan || loadingPcpVendor || loadingProviders;

  return (
    <>
      <div className="topFilter-section">
        <Spinner loading={showLoader}>
          <div className="filter-section__item">
            <Tooltip title={isDownloadDisabled ? "No Data Available for Download" : "Download XLS"}>
              <div
                className={`filter-section__item__download ${isDownloadDisabled ? "disable" : "enable"}`}
                onClick={isDownloadDisabled ? undefined : handleExportChronicBreakdownReport}
                style={{ cursor: isDownloadDisabled ? "not-allowed" : "pointer" }}
              >
                <Icon name="report-download" colorOfBrand={isDownloadDisabled ? "#838EA0" : ""} />
                <span>Download</span>
              </div>
            </Tooltip>
          </div>
        </Spinner>
      </div>
    </>
  );
};

export default TopFilters;